import { WaitLoadingModule } from './../common/waitLoading/waitLoading.module';
import { SubHeaderModule } from './../common/sub-header/sub-header.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';

import { searchOrganizationalUnitsComponent } from './searchOrganizationalUnits.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { DynamicDialogModule } from 'primeng-lts/dynamicdialog';
import { DirectivesModule } from '../../directives/directives.module';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { TreeModule } from 'primeng-lts/tree';

@NgModule({
  declarations: [searchOrganizationalUnitsComponent],
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    DynamicDialogModule,
    TreeModule,
    DirectivesModule,
    A11yModule,
    ScrollPanelModule,
    SubHeaderModule,
    WaitLoadingModule
  ],
  exports: [searchOrganizationalUnitsComponent, DirectivesModule]
})
export class searchOrganizationalUnitsModule { }
